export const SET_ALERT = "SET_ALERT";
export const SET_ALERTS = "SET_ALERTS";
export const REM_ALERT = "REM_ALERT";
export const REM_ALERTS = "REM_ALERTS";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT = "LOGOUT";
export const SET_LOADING = "SET_LOADING";
export const SET_LOADED = "SET_LOADED";
export const PASSWORD_CHANGE = "PASSWORD_CHANGE";

export const GET_PROFILE_DATA = "GET_PROFILE_DATA";
export const GET_FIELD_DATA = "GET_FIELD_DATA";
export const RESET_SUCCESS = "RESET_SUCCESS";
export const RESET_FAILED = "RESET_FAILED";
export const VERIFY_TOKEN_FAILED = "VERIFY_TOKEN_FAILED";
export const VERIFY_TOKEN_SUCCESS = "VERIFY_TOKEN_SUCCESS";
export const GET_PERSON_DATA = "GET_PERSON_DATA";

export const AUTH_ERROR = "AUTH_ERROR";
export const USER_LOADED = "USER_LOADED";
export const PERMISSIONS_LOADED = "PERMISSIONS_LOADED";

export const SET_PAGE_INFO = "SET_PAGE_INFO";
export const SET_SITE_SETTINGS = "SET_SITE_SETTINGS";

export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";

export const GET_LOG = "GET_LOG";
export const GET_LOGS = "GET_LOGS";

export const GET_REPORT = "GET_REPORT";
export const GET_REPORTS = "GET_REPORTS";

export const CLEAR_FILE = "CLEAR_FILE";
export const GET_FILE = "GET_FILE";
export const GET_FILES = "GET_FILES";
export const ADD_FILE = "ADD_FILE";   

export const GET_PROFILE_PRODUCTS = "GET_PROFILE_PRODUCTS";
export const GET_PROFILE_PRODUCT_SHARES = "GET_PROFILE_PRODUCT_SHARES";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const SET_PROFILE_PRODUCT = "SET_PROFILE_PRODUCT";
export const SET_PROFILE_PRODUCT_SHARE = "SET_PROFILE_PRODUCT_SHARE";
export const GET_PROFILE_METHODS = "GET_PROFILE_METHODS";
export const SET_PROFILE_UPDATED = "SET_PROFILE_UPDATED";
export const SET_METHOD_UPDATED = "SET_METHOD_UPDATED";
export const SET_METHOD_DELETED = "SET_METHOD_DELETED";

export const GET_INVOICES = "GET_INVOICES";
